export const editSmsAccount = (builder) => ({
    editSmsAccount: builder.mutation({
      query: (body) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/edit_registered_accounts',
          method: 'PUT',
          body: body,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  
  